import Vue from 'vue';
import Router from 'vue-router';


Vue.use(Router);


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: () => import('./views/HomeAuth.vue'),
  }, {
    path: '/register',
    name: 'register',
    component: () => import('./views/HomeAuth.vue'),
  }, {
    path: '/instructions/:icon?',
    name: 'instructions',
    props: true,
    component: () => import('./views/Game.vue'),
  }, {
    path: '/ready/:level',
    name: 'ready',
    props: true,
    component: () => import('./views/Game.vue'),
  }, {
    path: '/:level/complete',
    name: 'complete',
    props: true,
    component: () => import('./views/Game.vue'),
  },{
    path: '/game/:level',
    name: 'game',
    props: true,
    component: () => import('./views/Game.vue'),
  },{
    path: '/customise',
    name: 'customise',
    component: () => import('./views/Game.vue'),
  },
  {
    path: '/thank-you',
    name: 'congrats',
    component: () => import('./views/Congrats.vue'),
  },
  ],
});